export const sortByAccess = (a, b) => {
  const priority = ["Invited", "Created", "Joined", "Managing"];

  if (a.access === b.access) {
    return 0;
  }

  return priority.indexOf(a.access) < priority.indexOf(b.access) ? -1 : 1;
};
